import type { UnresolvedCommitDescriptor } from 'custom-types/UnresolvedCommitDescriptor';
import { safeLinkTo } from 'ts/commons/links/LinkTo';
import { Route as ModelCompareRoute } from 'ts/routes/_perspectives/model-compare/compare.$projectId';

/** Returns a URL for the model compare perspective. */
export function modelCompare(
	projectId: string,
	params: {
		t: UnresolvedCommitDescriptor;
		'left-path': string;
		'left-location': string;
		'right-path': string;
		'right-location': string;
	}
) {
	return safeLinkTo({
		to: ModelCompareRoute.to,
		params: { projectId },
		search: {
			t: params.t,
			'left-path': params['left-path'],
			'left-location': params['left-location'],
			'right-path': params['right-path'],
			'right-location': params['right-location']
		}
	});
}
